import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";

import WorkstationSelector from "./andonBoard/components/WorkstationSelector";

type WorkstationSelectorModalProps = {
  isOpen: boolean;
  selectedWorkstationIds: string[];
  workstationSelectorCb: (newIds: string[]) => void;
  setModalOpen: (isOpen: boolean) => void;
};

/** Used by EventExplorer to choose which workstations appear in the event list. */
function WorkstationSelectorModal(props: WorkstationSelectorModalProps) {
  const { t } = useTranslation();
  const {
    isOpen,
    selectedWorkstationIds,
    workstationSelectorCb,
    setModalOpen
  } = props;

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      aria-labelledby="select-workstations-dialog-title"
      PaperProps={{
        sx: {
          width: "90vw",
          maxWidth: "90vw"
        }
      }}
    >
      <DialogTitle id="select-workstations-dialog-title">
        {t("select workstations")}
      </DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 2
          }}
        >
          <WorkstationSelector
            selectedWorkstationIds={selectedWorkstationIds}
            setNewIdsCb={workstationSelectorCb}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mr: 2 }}>
          {selectedWorkstationIds.length} {t("workstations selected")}
        </Typography>
        <Button onClick={handleClose} color="inherit">
          {t("close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default WorkstationSelectorModal;
